import { render } from "./MyDepartment.vue?vue&type=template&id=d496dee0"
import script from "./MyDepartment.vue?vue&type=script&lang=js"
export * from "./MyDepartment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__